import React from 'react';
import { Icon, Popup } from 'semantic-ui-react';
import styles from './styles.module.scss';

const FormPopUp = ({
    label,
    content,
    popupClassName,
    labelClassName,
    iconClassName,
    inverted = true,
    horizontalOffset = 0,
    wide = 'very'
}) => (
    <>
        <label className={labelClassName}>{label}</label>
        <Popup
            trigger={<Icon name='question circle outline' className={[styles.popUpIcon, iconClassName].join(' ')} />}
            content={content}
            position='bottom center'
            className={[styles.popup, popupClassName].join(' ')}
            inverted={inverted}
            style={{ opacity: inverted ? 0.8 : 1 }}
            wide={wide}
            horizontalOffset={horizontalOffset}
        />
    </>
);

export default FormPopUp;
